'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.createRequestStatusMeta = createRequestStatusMeta;
exports.createRequestAction = createRequestAction;

var _fluxActions = require('flux-actions');

var _invariant = require('react-utils/invariant');

var _invariant2 = _interopRequireDefault(_invariant);

var _RequestStatusTypes = require('MeetingsBase/constants/RequestStatusTypes');

var RequestStatusTypes = _interopRequireWildcard(_RequestStatusTypes);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getStatusIndex(type) {
  var statusIndex = type ? type.lastIndexOf('_') : -1;
  if (statusIndex === -1) {
    throw new Error('exected an request action type in the form of ${NAMESPACE}_${REQUEST_STATUS} but received ' + type);
  }
  return statusIndex;
}

function getRequestNamespace(type) {
  var statusIndex = getStatusIndex(type);
  return type.substring(0, statusIndex);
}

function getRequestStatus(type) {
  var statusIndex = getStatusIndex(type);
  var requestStatus = type.substring(statusIndex + 1);
  (0, _invariant2.default)(RequestStatusTypes.hasOwnProperty(requestStatus), 'expected `requestStatus` to be defined in `MeetingsBase/constants/RequestStatusTypes` but got `%s`', requestStatus);
  return requestStatus;
}

function createRequestStatusMeta(type) {
  var namespace = getRequestNamespace(type);
  var requestStatus = getRequestStatus(type);
  return {
    request: {
      key: namespace,
      status: requestStatus
    }
  };
}

function createRequestAction(type) {
  var payloadCreator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var metadataCreator = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function () {
    return {};
  };

  return (0, _fluxActions.createAction)(type, payloadCreator, function () {
    return _extends({}, metadataCreator.apply(undefined, arguments), createRequestStatusMeta(type));
  });
}


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/workspace/MeetingsUI/MeetingsBase/target/src/MeetingsBase/static-1.2449/js/utils/actions.js
// module id = 190
// module chunks = 0